import "react-toastify/dist/ReactToastify.css";
import {
  setError,
  loadLinkedInProfilesData,
  setFilteredProfiles,
  setStatistics,
  setLoading,
} from "../slices/linkedinProfilesSlice";
import { 
  getLinkedInProfilesList, 
  createLinkedInProfile, 
  updateLinkedInProfile, 
  deleteLinkedInProfile,
  getLinkedInProfileById,
  searchLinkedInProfiles,
  getLinkedInProfilesByJD,
  getLinkedInProfilesByClient,
  getLinkedInProfilesByJDAndClient,
  getLinkedInProfilesStatistics
} from "../../utils/linkedinProfilesAPI";

export const getLinkedInProfiles = (params = {}) => async (dispatch) => {
  try {
    const response = await getLinkedInProfilesList(params);
    console.log("linkedin profiles list " + JSON.stringify(response.data.profiles));
    // Handle new response structure with success and data wrapper
    const profiles = response.success ? (response.data?.profiles || []) : [];
    dispatch(loadLinkedInProfilesData(profiles));
    dispatch(setError(null));
    dispatch(setLoading(false));
  } catch (error) {
    dispatch(setError(error.message));
  }
};

export const createLinkedInProfileAction = (profileData) => async (dispatch) => {
  try {
    const response = await createLinkedInProfile(profileData);
    console.log("created linkedin profile " + response);
    return response;
  } catch (error) {
    dispatch(setError(error.message));
    throw error;
  }
};

export const updateLinkedInProfileAction = (profileId, updateData) => async (dispatch) => {
  try {
    const response = await updateLinkedInProfile(profileId, updateData);
    console.log("updated linkedin profile " + response);
    return response;
  } catch (error) {
    dispatch(setError(error.message));
    throw error;
  }
};

export const deleteLinkedInProfileAction = (profileId) => async (dispatch) => {
  try {
    const response = await deleteLinkedInProfile(profileId);
    console.log("deleted linkedin profile " + response);
    return response;
  } catch (error) {
    dispatch(setError(error.message));
    throw error;
  }
};

export const getLinkedInProfileByIdAction = (profileId) => async (dispatch) => {
  try {
    const response = await getLinkedInProfileById(profileId);
    console.log("get linkedin profile by id " + response);
    return response;
  } catch (error) {
    dispatch(setError(error.message));
    throw error;
  }
};

export const searchLinkedInProfilesAction = (searchTerm, limit = 50) => async (dispatch) => {
  try {
    const response = await searchLinkedInProfiles(searchTerm, limit);
    console.log("search linkedin profiles " + response);
    return response;
  } catch (error) {
    dispatch(setError(error.message));
    throw error;
  }
};

export const getLinkedInProfilesByJDAction = (jdId, params = {}) => async (dispatch) => {
  try {
    const response = await getLinkedInProfilesByJD(jdId, params);
    console.log("get linkedin profiles by jd " + response);
    return response;
  } catch (error) {
    dispatch(setError(error.message));
    throw error;
  }
};

export const getLinkedInProfilesByClientAction = (clientId, params = {}) => async (dispatch) => {
  try {
    const response = await getLinkedInProfilesByClient(clientId, params);
    console.log("get linkedin profiles by client " + response);
    return response;
  } catch (error) {
    dispatch(setError(error.message));
    throw error;
  }
};

export const getLinkedInProfilesByJDAndClientAction = (jdId, clientId, params = {}) => async (dispatch) => {
  try {
    const response = await getLinkedInProfilesByJDAndClient(jdId, clientId, params);
    console.log("get linkedin profiles by jd and client " + response);
    return response;
  } catch (error) {
    dispatch(setError(error.message));
    throw error;
  }
};

export const getLinkedInProfilesStatisticsAction = () => async (dispatch) => {
  try {
    const response = await getLinkedInProfilesStatistics();
    console.log("get linkedin profiles statistics " + response);
    // Handle new response structure with success and data wrapper
    const statistics = response.success ? response.data : {};
    dispatch(setStatistics(statistics));
    return response;
  } catch (error) {
    dispatch(setError(error.message));
    throw error;
  }
};

// Filter profiles action
export const filterLinkedInProfilesAction = (filters, allProfiles = []) => async (dispatch) => {
  try {
    console.log('filterLinkedInProfilesAction - filters:', filters);
    console.log('filterLinkedInProfilesAction - allProfiles:', allProfiles);
    
    if (!Array.isArray(allProfiles)) {
      dispatch(setFilteredProfiles([]));
      return;
    }

    let filtered = [...allProfiles];
    console.log('filterLinkedInProfilesAction - filtered:', filtered);
    
    // Filter by search term
    if (filters.searchTerm && filters.searchTerm.trim()) {
      const searchTerm = filters.searchTerm.toLowerCase().trim();
      filtered = filtered.filter(profile => {
        const searchableFields = [
          String(profile.full_name || ''),
          String(profile.profile_id || ''),
          String(profile.title || ''),
          String(profile.linkedin_profile_link || ''),
          String(profile.description || ''),
          // Include client_jd_mapping keys and values in search
          ...(profile.client_jd_mapping ? Object.keys(profile.client_jd_mapping) : []),
          ...(profile.client_jd_mapping ? Object.values(profile.client_jd_mapping).flat() : [])
        ].map(field => field.toLowerCase());
        
        return searchableFields.some(field => field.includes(searchTerm));
      });
      console.log('filterLinkedInProfilesAction - filtered after search:', filtered);
    }

    // Filter by JD
    if (filters.selectedJDs && filters.selectedJDs.length > 0) {
      filtered = filtered.filter(profile => {
        if (!profile.client_jd_mapping) return false;
        const allJdIds = Object.values(profile.client_jd_mapping).flat();
        return filters.selectedJDs.some(jdId => allJdIds.includes(jdId));
      });
      console.log('filterLinkedInProfilesAction - filtered after JD:', filtered);
    }

    // Filter by Client
    if (filters.selectedClients && filters.selectedClients.length > 0) {
      filtered = filtered.filter(profile => {
        if (!profile.client_jd_mapping) return false;
        const clientIds = Object.keys(profile.client_jd_mapping);
        return filters.selectedClients.some(clientId => clientIds.includes(clientId));
      });
      console.log('filterLinkedInProfilesAction - filtered after client:', filtered);
    }

    // Filter by active status
    if (filters.activeOnly !== undefined) {
      filtered = filtered.filter(profile => profile.is_active === filters.activeOnly);
      console.log('filterLinkedInProfilesAction - filtered after active status:', filtered);
    }

    // Filter by date range
    if (filters.dateRange && filters.dateRange.length === 2 && filters.dateRange[0] && filters.dateRange[1]) {
      const startDate = new Date(filters.dateRange[0]);
      const endDate = new Date(filters.dateRange[1]);
      
      filtered = filtered.filter(profile => {
        const profileDate = new Date(profile.created_at);
        return profileDate >= startDate && profileDate <= endDate;
      });
      console.log('filterLinkedInProfilesAction - filtered after date range:', filtered);
    }

    console.log('Filtered profiles:', filtered.length, 'out of', allProfiles.length);
    dispatch(setFilteredProfiles(filtered));
    
  } catch (error) {
    console.error('Error filtering LinkedIn profiles:', error);
    dispatch(setError('Failed to filter LinkedIn profiles'));
  }
};
